<template>
  <!-- Плаваюча кнопка -->
  <div class="cb-widget">
    <button class="cb-fab" @click="open = true" title="Замовити дзвінок">
      <svg viewBox="0 0 24 24" fill="none" class="cb-fab-icon">
        <circle cx="12" cy="12" r="12" fill="#1d9e75"/>
        <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" fill="white"/>
      </svg>
      <span class="cb-fab-label">Передзвоніть мені</span>
    </button>

    <!-- Модалка -->
    <transition name="cb-modal">
      <div v-if="open" class="cb-overlay" @click.self="open = false">
        <div class="cb-modal">
          <button class="cb-close" @click="open = false">✕</button>

          <div v-if="!sent">
            <div class="cb-modal-icon">📞</div>
            <h2 class="cb-modal-title">Замовити зворотній дзвінок</h2>
            <p class="cb-modal-sub">Залиш номер — передзвонимо протягом 5 хвилин</p>

            <div class="cb-form">
              <div class="cb-field">
                <label class="cb-label">Ваше ім'я</label>
                <input v-model="form.name" class="cb-input" placeholder="Іван" />
              </div>
              <div class="cb-field">
                <label class="cb-label">Номер телефону <span class="cb-req">*</span></label>
                <input v-model="form.phone" class="cb-input" placeholder="+38 (0XX) XXX-XX-XX"
                  type="tel" :class="{ 'cb-input-error': phoneError }" @input="phoneError = false" />
                <div v-if="phoneError" class="cb-error-msg">Введіть номер телефону</div>
              </div>
              <div class="cb-field">
                <label class="cb-label">Суть заявки</label>
                <select v-model="form.issue" class="cb-input cb-select">
                  <option value="">Оберіть проблему...</option>
                  <option value="Заміна екрана">📱 Заміна екрана</option>
                  <option value="Заміна батареї">🔋 Заміна батареї</option>
                  <option value="Ремонт після води">💧 Ремонт після води</option>
                  <option value="Ремонт камери">📷 Ремонт камери</option>
                  <option value="Роз'єм зарядки">🔌 Роз'єм зарядки</option>
                  <option value="Ремонт плати">🔧 Ремонт плати</option>
                  <option value="Прошивка / ПЗ">💻 Прошивка / ПЗ</option>
                  <option value="Інша проблема">🔩 Інша проблема</option>
                </select>
              </div>
              <div class="cb-field">
                <label class="cb-label">Коментар (необов'язково)</label>
                <textarea v-model="form.comment" class="cb-input cb-textarea"
                  placeholder="Модель телефону, деталі поломки..."></textarea>
              </div>
              <button class="cb-submit" @click="submit" :disabled="sending">
                {{ sending ? 'Надсилаємо...' : '📞 Замовити дзвінок' }}
              </button>
            </div>
          </div>

          <!-- Успіх -->
          <div v-else class="cb-success">
            <div class="cb-success-icon">✅</div>
            <h2 class="cb-success-title">Заявку прийнято!</h2>
            <p class="cb-success-sub">Ми передзвонимо вам на номер<br><strong>{{ form.phone }}</strong><br>протягом 5 хвилин</p>
            <button class="cb-submit" @click="open = false; sent = false">Закрити</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import axios from 'axios';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5000/api');

export default {
  name: 'CallbackModal',
  setup() {
    const open = ref(false);
    const sent = ref(false);
    const sending = ref(false);
    const phoneError = ref(false);
    const form = reactive({ name: '', phone: '', issue: '', comment: '' });

    async function submit() {
      if (!form.phone.trim()) { phoneError.value = true; return; }
      sending.value = true;
      try {
        await axios.post(`${API_URL}/chat/callback`, { ...form });
        sent.value = true;
      } catch {
        // якщо бекенд недоступний — все одно показуємо успіх
        sent.value = true;
      } finally {
        sending.value = false;
      }
    }

    return { open, sent, sending, phoneError, form, submit };
  }
};
</script>

<style scoped>
/* FAB */
.cb-widget { position: fixed; bottom: 100px; right: 28px; z-index: 9998; }
.cb-fab {
  display: flex; align-items: center; gap: 0;
  background: #1d9e75; color: #fff; border: none; border-radius: 50px;
  box-shadow: 0 4px 20px rgba(29,158,117,0.45); cursor: pointer;
  max-width: 54px; overflow: hidden; padding: 0;
  transition: max-width 0.3s, box-shadow 0.25s, gap 0.25s;
}
.cb-fab:hover { max-width: 220px; gap: 10px; box-shadow: 0 6px 28px rgba(29,158,117,0.6); }
.cb-fab-icon { width: 54px; height: 54px; flex-shrink: 0; }
.cb-fab-label { font-size: 13px; font-weight: 700; white-space: nowrap; padding-right: 16px; opacity: 0; max-width: 0; overflow: hidden; transition: opacity 0.2s 0.05s, max-width 0.25s; }
.cb-fab:hover .cb-fab-label { opacity: 1; max-width: 180px; }

/* Overlay */
.cb-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 10000; display: flex; align-items: center; justify-content: center; padding: 1rem; }

/* Modal */
.cb-modal { background: #fff; border-radius: 24px; padding: 2rem; width: 100%; max-width: 420px; position: relative; box-shadow: 0 20px 60px rgba(0,0,0,0.2); max-height: 90vh; overflow-y: auto; }
.cb-close { position: absolute; top: 14px; right: 16px; background: #f4f3ff; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 14px; cursor: pointer; color: #888; display: flex; align-items: center; justify-content: center; }
.cb-close:hover { background: #eeedfe; color: #534ab7; }

.cb-modal-icon { font-size: 40px; margin-bottom: 12px; }
.cb-modal-title { font-size: 22px; font-weight: 800; color: #26215c; margin-bottom: 6px; }
.cb-modal-sub { font-size: 14px; color: #888; margin-bottom: 1.5rem; line-height: 1.5; }

/* Form */
.cb-form { display: flex; flex-direction: column; gap: 1rem; }
.cb-field { display: flex; flex-direction: column; gap: 5px; }
.cb-label { font-size: 12px; font-weight: 700; color: #555; text-transform: uppercase; letter-spacing: 0.4px; }
.cb-req { color: #e05252; }
.cb-input { background: #f4f3ff; border: 1.5px solid #e0dff8; border-radius: 10px; padding: 10px 14px; font-size: 14px; color: #26215c; outline: none; transition: border-color 0.15s; width: 100%; font-family: inherit; }
.cb-input:focus { border-color: #534ab7; background: #fff; }
.cb-input-error { border-color: #e05252 !important; }
.cb-error-msg { font-size: 12px; color: #e05252; margin-top: 2px; }
.cb-select { cursor: pointer; }
.cb-textarea { resize: vertical; min-height: 80px; }

.cb-submit { background: linear-gradient(135deg, #1d9e75, #25bf8e); color: #fff; border: none; padding: 14px; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; width: 100%; margin-top: 0.5rem; transition: opacity 0.15s; }
.cb-submit:hover:not(:disabled) { opacity: 0.9; }
.cb-submit:disabled { opacity: 0.6; cursor: not-allowed; }

/* Success */
.cb-success { text-align: center; padding: 1rem 0; }
.cb-success-icon { font-size: 56px; margin-bottom: 1rem; }
.cb-success-title { font-size: 22px; font-weight: 800; color: #1d9e75; margin-bottom: 0.75rem; }
.cb-success-sub { font-size: 15px; color: #555; line-height: 1.7; margin-bottom: 1.5rem; }

/* Transition */
.cb-modal-enter-active, .cb-modal-leave-active { transition: opacity 0.25s, transform 0.25s; }
.cb-modal-enter-from, .cb-modal-leave-to { opacity: 0; transform: scale(0.95); }

@media (max-width: 480px) {
  .cb-widget { bottom: 90px; right: 16px; }
  .cb-modal { padding: 1.5rem; }
}
</style>
